// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Checkbox.module.scss  */
.Checkbox-module-Root_6m3 {
  position: relative;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  width: fit-content;
  border-radius: 4px; }
  .Checkbox-module-Root_6m3:focus-within {
    outline: 4px solid var(--color-control-border-color-focus); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Checkbox/Checkbox.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB,EAAE;EACpB;IACE,0DAA0D,EAAE","sourcesContent":["/*  imported from Checkbox.module.scss  */\n.Checkbox-module-Root_6m3 {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  width: fit-content;\n  border-radius: 4px; }\n  .Checkbox-module-Root_6m3:focus-within {\n    outline: 4px solid var(--color-control-border-color-focus); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
